import { cn } from "@/lib/utils";

function Bar({ className }: { className?: string }) {
  return <div className={cn("animate-pulse rounded bg-muted", className)} />;
}

/** Generic table + card-grid skeleton shared by all three subscription tabs. */
export function SubscriptionsSkeleton({ columns = 6 }: { columns?: number }) {
  return (
    <>
      {/* Desktop */}
      <div className="hidden lg:block">
        <div className="overflow-hidden rounded-2xl border border-border/60 bg-card shadow-sm">
          <div className="bg-muted/40 px-4 py-3">
            <div className="flex gap-10">
              {Array.from({ length: columns }).map((_, i) => (
                <Bar key={i} className="h-3 w-14" />
              ))}
            </div>
          </div>
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className={cn(
                "flex items-center gap-6 px-4 py-3.5",
                i !== 5 && "border-b border-border/40",
              )}
            >
              <div className="flex flex-1 items-center gap-2.5">
                <div className="size-7 animate-pulse rounded-full bg-muted" />
                <div className="space-y-1">
                  <Bar className="h-3.5 w-32" />
                  <Bar className="h-2.5 w-40 bg-muted/50" />
                </div>
              </div>
              <Bar className="h-3.5 w-24" />
              <Bar className="h-3.5 w-20" />
              <Bar className="h-3.5 w-16" />
              <Bar className="h-6 w-20 rounded-full bg-muted/50" />
              <Bar className="h-7 w-16 rounded-md bg-muted/50" />
            </div>
          ))}
        </div>
      </div>

      {/* Mobile/Tablet */}
      <div className="grid gap-3 sm:grid-cols-2 lg:hidden">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-border/60 bg-card p-4 shadow-sm"
          >
            <div className="flex items-center gap-2.5">
              <div className="size-7 animate-pulse rounded-full bg-muted" />
              <div className="space-y-1">
                <Bar className="h-3.5 w-28" />
                <Bar className="h-2.5 w-36 bg-muted/50" />
              </div>
            </div>
            <div className="mt-3 grid grid-cols-2 gap-2 border-t border-border/40 pt-3">
              <Bar className="h-3.5 w-20" />
              <Bar className="h-3.5 w-16" />
              <Bar className="h-3.5 w-24" />
              <Bar className="h-3.5 w-14" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
